import { useCallback, useEffect } from 'react'
import { useMachine } from '@xstate/react'

import { navigoDriversMachine } from './stateMachine'
import { usePermissions } from './usePermissions'

export function useDriversNavigoMachine() {
  const permissions = usePermissions()

  // ----------------------------------
  // INITIALIZATION
  // ----------------------------------
  const [stateMachine, send] = useMachine(navigoDriversMachine, {
    context: { permissions },
  })

  // ----------------------------------
  // ACTIONS
  // ----------------------------------
  const actions = {
    toggleExpanded: useCallback(() => send('TOGGLE_EXPANDED'), [send]),
  }

  // ----------------------------------
  // CONTEXT UPDATES
  // ----------------------------------
  useEffect(() => {
    send({ type: 'UPDATE_ACTION_PERMISSIONS', permissions })
  }, [send, permissions])

  // ----------------------------------
  // RETURN
  // ----------------------------------
  return {
    actions,
    currentState: stateMachine.value,
    data: {
      expanded: stateMachine.context.expanded,
      permissions: stateMachine.context.permissions,
    },
  }
}
